import React from 'react';
import styles from './AvatarGroup.module.sass';

const AvatarGroup = ({ children }: any) => {
    return <div className={styles['avatargroup']}>
        { children }
    </div>
}

export default AvatarGroup;